/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_TitleInputs */

const en_why_listening_zotero_title = /** @type {(inputs: Why_Listening_Zotero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Zotero library, ready to play`)
};

const es_why_listening_zotero_title = /** @type {(inputs: Why_Listening_Zotero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu biblioteca de Zotero, lista para escuchar`)
};

/**
* | output |
* | --- |
* | "Your Zotero library, ready to play" |
*
* @param {Why_Listening_Zotero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_title = /** @type {((inputs?: Why_Listening_Zotero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_title(inputs)
	return en_why_listening_zotero_title(inputs)
});